import { AuthService } from './../auth.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from '../../shared/common/common.service';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoggedOutComponent implements OnInit {
  public loginUrl: string;

  constructor(private commonService: CommonService, private authService: AuthService) { }

  ngOnInit() {
    this.commonService.showLoader(false);
    this.loginUrl = this.authService.isEmployeeLogin ? '/auth/internal-login' : '/auth/login';
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/logged-out/logged-out.component.ts